import { useMemo, useRef } from 'react'
import { createAiClient, type AiClient } from '@rammetec/app-kit/ai'
import { useSessionContext } from '@vectorhub/application'
import { authService } from '@/authService'
import { env } from '@/config/env'

/** Stable AI client; org id is read at call time via ref. */
export function useAiClient(): AiClient {
  const { currentOrgId } = useSessionContext()
  const orgRef = useRef(currentOrgId)
  orgRef.current = currentOrgId

  return useMemo(
    () =>
      createAiClient({
        baseUrl: env.systemApiUrl ?? '',
        getIdToken: () => authService.getIdToken(),
        getOrganizationId: () => Promise.resolve(orgRef.current),
      }),
    [],
  )
}

export function isAiConfigured(): boolean {
  return Boolean(env.systemApiUrl?.trim())
}
